import { changePasswordToken } from 'api/change-password'
import { HelpIcon } from 'assets/icons'
import EmailIcon from 'assets/icons/EmailIcon'
// import SmsIcon from 'assets/icons/SmsIcon'

import RecoveryPasswordOptions from 'components/RecoveryPasswordOptions'
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'
import TextButton from 'components/textButton'

import { MeContext } from 'contexts/me'

import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { redirectWhatsApp } from 'utils/redirectWhatsApp'

const PasswordRecovery = () => {
  const [loading, setLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)

  const [isMethod, setIsMethod] = useState({
    sms: false,
    email: true
  })

  const navigate = useNavigate()
  const { me } = useContext(MeContext)

  const handleSendToken = () => {
    setLoading(true)
    setIsDisabled(true)
    if (isMethod.email) {
      changePasswordToken({ contact_type: 'EMAIL' })
        .then((data) => {
          if (data.success) {
            navigate('email')
            setIsDisabled(false)
          }
        })
        .catch((error) => console.warn(error))
    }
    // Método SMS comentando.
    // else if (isMethod.sms) {
    //   changePasswordToken({ contact_type: 'SMS' }).then((data) => {
    //     if (data.success) {
    //       navigate('sms')
    //       setIsDisabled(false)
    //     }
    //   }).catch((error) => {
    //     if (error) setLoading(false)
    //   })
    // }
    else {
      setLoading(false)
    }
  }

  return (
    <div>
      <PageWrapper title='Cambiar contraseña'>
        <section className='md:max-w-564 md:flex md:items-end md:flex-col mx-auto h-[82vh] flex flex-col justify-between'>
          <div>
            <p className='font-medium text-xs text-black leading-4 my-3'>
              ¡Seleccioná el método por el cual querés recibir el link que te
              habilitará a restablecer tu contraseña!
            </p>

            {/* <RecoveryPasswordOptions onClick={() => setIsMethod({ email: false, sms: true })} isTouched={isMethod.sms} icon={<SmsIcon />} content={{ title: 'SMS', description: 'Recibirás un link de ingreso a tu celular' }} /> */}
            <RecoveryPasswordOptions
              onClick={() => setIsMethod({ email: true, sms: false })}
              isTouched={isMethod.email}
              icon={<EmailIcon />}
              content={{
                title: 'Email',
                description: 'Recibirás un link de ingreso a tu cuenta de email'
              }}
            />
          </div>

          <div className='w-full pb-3'>
            <div className='flex flex-row w-full justify-evenly items-center mt-7 mb-5'>
              <HelpIcon variant='GREEN' />
              <p className='font-manrope w-[90%] font-bold text-purple-900 text-xs leading-5'>
                Recordá que este link o código no será pedido por nadie del
                equipo de Waynimóvil.{' '}
              </p>
            </div>
            <div className='w-full mt-auto mb-6'>
              <TextButton
                className='font-bold text-xs text-purple-900 leading-4 flex w-full justify-center'
                handleFunction={() =>
                  redirectWhatsApp(me?.profile?.name, 'pwd')
                }
              >
                Necesito ayuda para ingresar
              </TextButton>
              <PrimaryButton
                type='submit'
                buttonText='Enviar link'
                className='mt-5'
                isLoading={loading}
                isDisabled={loading}
                primaryButtonFunction={() => {
                  handleSendToken()
                }}
              />
            </div>
          </div>
        </section>
      </PageWrapper>
    </div>
  )
}

export default PasswordRecovery
